import { always, cond, equals, isNil, T } from 'ramda';
import { LAYOUT_AUTH, LAYOUT_SECURED, useLayoutContext } from '../context/layout-context';
import SecuredLayout from './secured-layout';
import AuthLayout from './auth-layout';

const Layout = ({ children, ...restProps }) => {
  const { layout } = useLayoutContext();
  const UserLayout = cond([
    [equals(LAYOUT_SECURED), always(SecuredLayout)],
    [equals(LAYOUT_AUTH), always(AuthLayout)],
    [T, null]
  ])(layout);

  if (isNil(UserLayout)) return null;

  return <UserLayout {...restProps}>{children}</UserLayout>;
};

export default Layout;
